import React, { useEffect, useState } from 'react';
import Button from '../../../../../component/ui/Button';
import Modal from '../../../../../component/modal/Modal';
import InputField from '../../../../../component/form/FormInput';
import deleteIcon from '../../../../../assets/image/delete-button-svgrepo-com.svg';
import {
	createCurrencies,
	deleteCurrency,
	getCurrencyList,
} from '../../../../../services/settings/organization';
import { toast } from 'react-toastify';
import PageLoader from '../../../../../component/PageLoader';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import SettingHeaderComponent from '../../components/settingHeaderComponent';

export default function Currencies({ activeTab }) {
	const [currenciesList, setCurrencies] = useState([]);

	const [error, setError] = useState({});
	const [isEdit, setIsEdit] = useState(false);
	const [loader, setLoader] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const [isOpenModal, setIsOpenModal] = useState(false);
	const [sortDirection, setSortDirection] = useState({});
	const [params, setParams] = useState({
		pageSize: 10000,
		page: 1,
		orderBy: '',
		sortBy: '',
		filterBy: '',
		filterValue: '',
	});
	const [currencyForm, setCurrencyForm] = useState({
		currency_code: '',
		currency_symbol: '',
		currency_name: '',
		decimal_place: '',
		currency_id: null,
		base_currency: false,
	});
	const [hoveredRow, setHoveredRow] = useState(null);
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};
	const handleFormData = (key, value, required = false) => {
		setCurrencyForm((prev) => ({
			...prev,
			[key]: value,
		}));
		if (required) {
			var newError = { ...error };
			if (value === '' || value === null || value === undefined) {
				newError[key] = `Please enter ${key.split('_').join(' ')} in field`;
			} else {
				delete newError[key];
			}
			setError(newError);
		}
	};

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.order_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.order_by]: newDirection });
		setParams((prev) => ({
			...prev,
			orderBy: param.order_by,
			sortBy: newDirection,
		}));
	};

	const resetCurrencyField = () => {
		const data = {
			currency_code: '',
			currency_symbol: '',
			currency_name: '',
			decimal_place: '',
			currency_id: null,
			base_currency: false,
		};
		setCurrencyForm(data);
	};

	const getCurrencies = async () => {
		try {
			setLoading(true);
			const { currencies } = await getCurrencyList(params);
			setCurrencies(currencies);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setLoading(false);
		}
	};

	const setCurrentCurrencyDetail = (index, isEditData = false) => {
		if (isEditData) {
			const data = currenciesList[index];
			const currencyElem = {
				currency_code: data.currency_code,
				currency_symbol: data.currency_symbol,
				currency_name: data.currency_name,
				decimal_place: data.decimal_place,
				currency_id: data.organisation_currency_id,
				base_currency: data.base_currency,
			};
			setCurrencyForm(currencyElem);
			setIsEdit(true);
		}
		setIsOpenModal(true);
	};

	function checkValidation() {
		const newError = { ...error };
		if (
			!currencyForm.currency_code ||
			currencyForm.currency_code === '' ||
			currencyForm.currency_code === undefined
		) {
			newError.currency_code = 'Please enter currency code in field.';
		} else {
			delete newError.currency_code;
		}
		if (
			!currencyForm.currency_symbol ||
			currencyForm.currency_symbol === '' ||
			currencyForm.currency_symbol === undefined
		) {
			newError.currency_symbol = 'Please enter currency symbol in the field';
		} else {
			delete newError.currency_symbol;
		}
		if (
			!currencyForm.currency_name ||
			currencyForm.currency_name === '' ||
			currencyForm.currency_name === undefined
		) {
			newError.currency_name = 'Please enter currency name in the field';
		} else {
			delete newError.currency_name;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handleCurrency = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error('Creating Currencies failed! Please fill required fields.');
		} else {
			try {
				setLoader(true);
				var body = {
					currency_code: currencyForm.currency_code,
					currency_name: currencyForm.currency_name,
					currency_symbol: currencyForm.currency_symbol,
					decimal_place: currencyForm.decimal_place,
					base_currency: currencyForm.base_currency,
					...(isEdit && { currency_id: currencyForm.currency_id }),
				};
				const res = await createCurrencies(body);
				if (res.success) {
					setIsOpenModal(false);
					toast.success(res.message);
					resetCurrencyField();
					getCurrencies();
				} else {
					toast.error(res.message || 'something went wrong!');
				}
			} catch (error) {
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setLoader(false);
			}
		}
	};

	const handleDeleteCurrency = async (id) => {
		try {
			const res = await deleteCurrency(Number(id));
			if (res.success === true) {
				toast.success(res.message);
				getCurrencies();
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	useEffect(() => {
		getCurrencies();
	}, [params]);

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				buttons={[
					{
						id: 1,
						disabled: false,
						className: 'btn-primary',
						add: true,
						close: false,
						button: 'Add New Currency',
						handler: () => {
							setIsOpenModal(true);
							resetCurrencyField();
						},
					},
				]}
			/>
			{isLoading ? (
				<PageLoader />
			) : (
				<div
					className="m-3"
					style={{
						position: 'fixed',
						height: 'calc(100% - 132px)',
						overflowY: 'auto',
						overflowX: 'hidden',
					}}
				>
					<table className="currency-table">
						<thead>
							<tr>
								{['NAME', 'SYMBOL', ''].map((item) => (
									<th
										key={item}
										className={`cursor-pointer ${item === 'NAME' ? 'w-100' : item === 'SYMBOL' ? 'w-25 text-center' : 'w-25'
											}`}
										onClick={() => {
											if (item !== '') {
												sortDataList({ order_by: 'currency_' + item.toLowerCase() });
											}
										}}
									>
										<div className="d-flex align-items-center gap-4">
											{item}
											{item === 'NAME' && sortIconMap[sortDirection.currency_name]}
											{item === 'SYMBOL' && sortIconMap[sortDirection.currency_symbol]}
										</div>
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{currenciesList.map((cur, index) => (
								<tr
									key={index}
									onMouseEnter={() => setHoveredRow(index)}
									onMouseLeave={() => setHoveredRow(null)}
								>
									<td className="d-flex gap-4 align-items-center">
										<p>{cur.currency_name}</p>
										{cur.base_currency && <p className="base-tag">Base Currency</p>}
									</td>
									<td>{cur.currency_symbol}</td>
									<td className="actions-cell">
										<div
											className={`action-buttons ${hoveredRow === index ? 'show-actions' : ''
												}`}
										>
											<div
												className="fs-5 fw-light cursor-pointer text-dark"
												onClick={() => setCurrentCurrencyDetail(index, true)}
											>
												Edit
											</div>

											<div className="fs-5 fw-semibold text-dark">|</div>

											<img
												alt="delete"
												src={deleteIcon}
												className="cursor-pointer"
												onClick={() =>
													handleDeleteCurrency(cur.organisation_currency_id)
												}
												width="14"
												height="14"
											/>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}
			{isOpenModal && (
				<Modal
					className="currency_model"
					title={`${isEdit ? 'Edit' : 'Add'} Currency`}
					isOpen={isOpenModal}
					onClose={() => {
						setIsOpenModal(false);
						setIsEdit(false);
					}}
					cancelButton={() => {
						setIsOpenModal(false);
						setIsEdit(false);
					}}
				>
					<div className="d-flex my-3 gap-2">
						<div className="col-6">
							<InputField
								label="Currency Code"
								placeholder="Currency Code"
								type="text"
								autoFocus={true}
								required={true}
								value={currencyForm.currency_code}
								onChange={(value) => handleFormData('currency_code', value, true)}
								error={error?.currency_code}
							/>
						</div>
						<div className="col-6">
							<InputField
								label="Currency Synmbol"
								placeholder="Currency symbol"
								type="text"
								required={true}
								value={currencyForm.currency_symbol}
								onChange={(value) => handleFormData('currency_symbol', value, true)}
								error={error?.currency_symbol}
							/>
						</div>
					</div>
					<div className="d-flex my-3 gap-2">
						<div className="col-6">
							<InputField
								label="Currency Name"
								placeholder="Currency name"
								type="text"
								required={true}
								value={currencyForm.currency_name}
								onChange={(value) => handleFormData('currency_name', value, true)}
								error={error?.currency_name}
							/>
						</div>
						<div className="col-6">
							<InputField
								label="Decimal Places"
								placeholder="Decimal places"
								type="text"
								required={false}
								value={currencyForm.decimal_place}
								onChange={(valueData) => {
									var value = valueData?.replace(/[^0-9.]/g, '');
									handleFormData('decimal_place', value);
								}}
								error={error?.decimal_place}
							/>
						</div>
					</div>

					<div className="d-flex align-items-center justify-content-end gap-4 mt-4">
						<Button
							type="button"
							button={isEdit ? 'Update' : 'Save'}
							disabled={loader}
							loader={loader}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => handleCurrency()}
						/>
						<Button
							type="button"
							button={`Cancel`}
							className="mt-0 px-4 btn-gray relative"
							onClick={() => {
								setIsOpenModal(false);
								setIsEdit(false);
							}}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
}
